import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import arthereumProvider from "../../backend/ArthereumProvider";
import "../../index.css";
import { PAGE_NAME } from "../../types";
import useThemeHook from "../hooks/useThemeHook";
import { useTranslationHook } from "../hooks/useTranslationHook";
import { actions } from "../redux";
import SectionTitle from "./SectionTitle";
import UserHorizontalCard from "./UserHorizontalCard";
import LoadingIndicator from "../components/LoadingIndicator";

const RecentUsersInteractedWith = ({ row = false }: { row?: boolean }) => {
  const [isLoading, setIsLoading] = useState(false);
  const recentUsers = useSelector(
    (state: any) => state?.recentUsersIInteractedWith
  );
  const userData = useSelector((state: any) => state?.actualUser);
  const dispatch = useDispatch();
  const theme = useThemeHook();
  const navigate = useNavigate();
  const getTranslationText = useTranslationHook();

  async function getRecentTransactionPartners() {
    try {
      if (recentUsers?.length === 0) {
        setIsLoading(true);
        const data = await arthereumProvider.getRecentTransactionPartners(
          userData?.user?.id
        );
        dispatch(actions.setRecentUsersIInteractedWith(data.recentPartners));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getRecentTransactionPartners();
  }, []);

  const goToCryptoView = (crypto: any) => {
    navigate(PAGE_NAME.CRYPTO_VIEW_PAGE, { state: { crypto } });
  };

  return (
    <>
      {isLoading && (
        <div className="w-full flex flex-row items-center justify-center py-8">
          <LoadingIndicator />
        </div>
      )}

      <div
        className={`w-full flex items-start justify-start flex-col pb-2 ${
          row ? "overflow-x-scroll" : ""
        } ${row ? "" : "pt-5"} hide-scrollbar`}
      >
        {!isLoading && recentUsers?.length !== 0 && (
          <div className="flex flex-row gap-3 items-center justify-between mb-3 px-3 w-full">
            <SectionTitle text={getTranslationText("recent_interactions")} />
          </div>
        )}

        <div className="flex gap-3 overflow-x-auto hide-scrollbar w-full px-3">
          {!isLoading &&
            recentUsers?.map((user: any, index: number) => {
              return (
                <div
                  key={user?.id || index}
                  className="flex-shrink-0 transition-transform duration-200 hover:scale-105"
                >
                  <UserHorizontalCard userData={user} />
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default RecentUsersInteractedWith;